import { graphql } from "gql.tada";
import { MetadataFragment } from "./fragments/MetadataFragment";
import { LinkFragment } from "./fragments/LinkFragment";
import { IconGridFragment } from "./fragments/IconGridFragment";
import { FootnoteFragment } from "./fragments/FootnoteFragment";
import { ArticleSideBySideImageFragment } from "./fragments/ArticleSideBySideImageFragment";

export const GetArticlePageBySlug = graphql(
  /* GraphQL */ `
    query GetArticlePageBySlug(
      $locale: String
      $preview: Boolean
      $slug: String
    ) {
      articlePageCollection(
        locale: $locale
        preview: $preview
        where: { slug: $slug }
        limit: 1
      ) {
        items {
          __typename
          title
          modalTitle
          isVideoModal
          heroImage {
            contentType
            url
          }
          subtitle
          slug
          metadata {
            ...MetadataFragment
          }
          body {
            json
            links {
              entries {
                inline {
                  sys { id }
                  __typename
                  ... on Link { ...LinkFragment }
                  ... on Footnote { ...FootnoteFragment }
                }
                block {
                  sys { id }
                  __typename
                  ... on Link { ...LinkFragment }
                  ... on IconGrid { ...IconGridFragment }
                  ... on SideBySideMedia { ...ArticleSideBySideImageFragment }
                }
                hyperlink {
                  sys { id }
                  __typename
                  ... on ArticlePage { slug }
                  ... on ContentHubPage { slug }
                  ... on ConversionPage { slug }
                  ... on EditorialPage { slug }
                  ... on FaqPage { slug }
                  ... on Homepage { slug }
                  ... on ProductPage { slug }
                  ... on TermsPage { slug }
                  ... on CreativeSpecsPage { slug }
                }
              }
              assets {
                __typename
                block {
                  sys { id }
                  url
                  contentType
                }
              }
            }
          }
          nextUpLabel
          nextArticle {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [MetadataFragment, LinkFragment, IconGridFragment, FootnoteFragment, ArticleSideBySideImageFragment]
);
